export const NOTIFICATION_DEFAULT = 'default'

export const NOTIFICATION_DENIED = 'denied'

export const NOTIFICATION_GRANTED = 'granted'
